import { Layout } from "~/pages/layout";

export function DatenschutzPage() {
  return (
    <Layout>
      <section className="bg-green-9 py-20 sm:py-24">
        <div className="container">
          <h2 className="title-36 sm:title-40 md:title-44 lg:title-48 text-center text-white">
            Datenschutz
          </h2>
        </div>
      </section>
      <section>
        <div className="container py-20 space-y-20 ">
          <div className="prose max-w-screen-sm mx-auto">
            <h2>I. Begriffsbestimmungen</h2>
            <p>
              Diese Datenschutzerklärung beruht auf den in der DSGVO verwendeten
              Begrifflichkeiten.
            </p>

            <h2>II. Verantwortlicher</h2>
            <p>
              Datenschutzrechtlich Verantwortlicher gem. Art. 24 und Art. 4 Nr.
              7 DSGVO ist:
            </p>
            <p>Mieten Law Clinic Berlin e.V.</p>
            <p>
              Email:{" "}
              <a href="mailto:kontakt@mietenlawclinic.de">
                kontakt@mietenlawclinic.de
              </a>
            </p>
            <p>
              Postanschrift:
              <br />
              Mieten Law Clinic Berlin e.V.
              <br />
              c/o Fachbereich Rechtswissenschaften
              <br />
              Sekretariat Univ-Prof. Dr. Rödl
              <br />
              Van&apos;t-Hoff-Str. 8
              <br />
              14195 Berlin
            </p>

            <h2>
              III. Informationen über die Verarbeitung Personenbezogener Daten
              der Website-Nutzer*innen nach Art. 13 DSGVO
            </h2>

            <h3>
              Welche Personenbezogene Daten werden auf der Website gesammelt?
            </h3>

            <h4>1. Beschreibung der gesammelten Daten</h4>

            <h5>a. Technisch notwendiges Tracking</h5>
            <p>
              Um den sogenannten Mietencheck durchzuführen ist es notwendig,
              seitenübergreifend die abgegebenen Antworten der Nutzer*innen zu
              speichern. Dabei werden:
            </p>
            <ul>
              <li>
                Die Antworten zu den einzelnen Merkmalen des Mietenchecks bzw.
                Mietspiegels auf unseren Servern gespeichert. Dabei werden
                allerdings keine personenbezogenen Daten gespeichert,
                insbesondere erfolgt die Speicherung also ohne die angegebenen
                Adressdaten der Nutzer*innen. Adressdaten der Nutzer*innen
                werden ausschließlich dann auf unseren Servern gespeichert, wenn
                die Nutzer*innen sich einen Link zur späteren Weiterbeantwortung
                des Mietenchecks – gegebenenfalls auf einem anderen Gerät –
                zuschicken lassen und dabei explizit in die Speicherung ihrer
                Adressdaten zu diesem Zwecke eingewilligt haben.
              </li>
              <li>
                Die Antworten zu den einzelnen Merkmalen des Mietenchecks bzw.
                Mietspiegels im Browser der Nutzer*innen gespeichert. Dabei
                werden auch die eingegebenen Adressdaten gespeichert.
              </li>
            </ul>

            <h5>b. Analysedaten</h5>
            <p>Zu Analysezwecken werden folgende Daten erhoben:</p>
            <ul>
              <li>
                Die Kombination der Antworten, welche der*die jeweilige
                Nutzer*in abgegeben hat ohne personenbezogene Daten bzw.
                Adressdaten oder IP-Adressen.
              </li>
              <li>
                Statistische Auswertungen wie häufig bestimmte Antworten
                ausgewählt wurden.
              </li>
            </ul>

            <h4>
              2. Rechtsgrundlage für die Datenverarbeitung nach Art. 6 Abs. 1
              und Art. 5 Abs. 1 lit. a DSGVO
            </h4>
            <p>
              Soweit nur die einzelnen Antworten auf die Merkmale ohne
              irgendwelche Adressdaten gespeichert werden, handelt es sich dabei
              nicht um personenbezogene Daten, da diese auch unter Zuhilfenahme
              weiterer Informationen nicht realistischerweise einer natürlichen
              Person zugeordnet werden können, wie es unter dem relativen
              Konzept der Personenbezogenheit nach Art. 4 Nr. 1 DSGVO notwendig
              ist, um von personenbezogenen Daten auszugehen (siehe etwa EuGH
              C-604/22 Rn. 40 mwN).
            </p>
            <p>
              Soweit auch die Adressdaten der Nutzer*innen genutzt werden,
              stützt sich dies auf Art. 6 Abs. 1 lit. f DSGVO, also auf unser
              berechtigtes Interesse an der Speicherung personenbezogener Daten.
              Für das Überwiegen des Speicherinteresses gegenüber dem Recht auf
              Schutz der personenbezogenen Daten der Betroffenen spricht hier,
              dass nur explizit auf unserer Website an uns übermittelte Daten
              gespeichert werden, dass diese gerade dafür genutzt werden, die
              Nutzer*in ohne eigenes Gewinnstreben bei der Rechtsfindung zu
              unterstützen und dass Adressdaten nicht an Dritte übermittelt
              werden.
            </p>
            <p>
              Soweit es um die Speicherung der Adressdaten zur späteren
              Weiterbeantwortung der Fragen – gegebenenfalls auf einem anderen
              Gerät – geht, stützt sich die Datenverarbeitung zusätzlich auf die
              Einwilligung der Betroffenen nach Art. 6 Abs. 1 lit. a DSGVO.
            </p>

            <h4>
              3. Rechtsgrundlage für die Speicherung von Informationen in der
              Endeinrichtung der Nutzer*innen nach § 25 TTDSG
            </h4>
            <p>
              Insofern Informationen in der Endeinrichtung der Nutzer*innen
              gespeichert werden bzw. auf diese zugegriffen wird, geschieht dies
              nur um die seitenübergreifende Beantwortung der Fragen im Rahmen
              des Mietenchecks zu ermöglichen. Sie ist daher für die
              Funktionalität dieser Services unbedingt erforderlich, um diese
              Services den Nutzer*innen überhaupt anbieten zu können. Es handelt
              sich daher um eine technisch unbedingt erforderliche Maßnahme nach
              § 25 Abs. 2 Nr. 2 TTDSG und ist daher ohne Einwilligung der
              Nutzer*innen möglich.
            </p>

            <h4>4. Übermittlung der Daten an Dritte</h4>
            <p>
              Eine Übermittlung personenbezogener Daten an Dritte erfolgt nicht.
              Alleine die Möglichkeit statistisch zusammengefasste Daten für
              politische Zwecke weiterzuverwenden, halten wir uns offen (etwa in
              dem Sinne „23 % der Nutzer*innen gaben an isolierte Fenster zu
              haben“). Dabei handelt es sich aber ausschließlich um anonyme,
              statische Daten, weshalb für diese Übermittlung auch keine
              Rechtsgrundlage notwendig ist und auch die Unterrichtung der
              Betroffenen entbehrlich bzw. unmöglich ist, da uns keine
              Möglichkeit der Reidentifizierung zur Verfügung steht.
            </p>

            <h4>5. Dauer der Speicherung</h4>
            <p>
              Die Daten werden nur solange gespeichert wie notwendig. Um den
              späteren Zugriff auf das Ergebnis zu ermöglichen und in Anbetracht
              der Tatsache, dass dieses ggf. auch für einen Gerichtsprozess von
              Relevanz sein kann, werden die Daten drei Jahre nach der letzten
              Nutzung eines*r bestimmten Nutzer*in gelöscht. Darüber hinaus
              haben Nutzer*innen stets das Recht die unverzügliche Löschung
              ihrer Daten zu verlangen (siehe IV. 4.).
            </p>

            <h4>6. Externe Inhalte</h4>
            <p>
              Diese Datenschutzerklärung gilt nur Inhalte unmittelbar auf dieser
              Website. Für den Datenschutz auf externen, bei uns verlinkten
              Websiten, übernehmen wir keine Verantwortung.
            </p>

            <h2>IV. Ausübung von Betroffenenrechten</h2>
            <p>
              Die Betroffenenrechte können unmittelbar gegenüber dem angebenden
              Verantwortlichen ausgeübt werden.
            </p>
            <p>
              Weiterführende Hinweise zur Ausübung der Betroffenenrechte finden
              sie unter:{" "}
              <a
                href="https://www.bfdi.bund.de/DE/Buerger/Basiswissen/Betroffenenrechte/BetroffenenRechte_node.html"
                target="_blank"
                rel="noopener"
              >
                https://www.bfdi.bund.de/DE/Buerger/Basiswissen/Betroffenenrechte/BetroffenenRechte_node.html
              </a>
            </p>

            <h4>1. Recht auf Auskunft</h4>
            <p>
              Sie können Auskunft nach Art. 15 DS-GVO über Ihre
              personenbezogenen Daten verlangen, die wir verarbeiten.
            </p>

            <h4>2. Recht auf Widerspruch</h4>
            <p>
              Sie haben ein Recht auf Widerspruch aus besonderen Gründen. Sie
              haben das Recht, aus Gründen, die sich aus Ihrer besonderen
              Situation ergeben, jederzeit gegen die Verarbeitung Ihrer
              personenbezogenen Daten, die aufgrund von Artikel 6 Abs. 1
              Buchstabe f DS-GVO erfolgt, Widerspruch einzulegen. Der
              Verantwortliche verarbeitet die personenbezogenen Daten dann nicht
              mehr.
            </p>

            <h4>3. Recht auf Berichtigung</h4>
            <p>
              Sollten die Sie betreffenden Angaben nicht (mehr) zutreffend sein,
              können Sie nach Art. 16 DS-GVO eine Berichtigung verlangen.
              Sollten Ihre Daten unvollständig sein, können Sie eine
              Vervollständigung verlangen.
            </p>

            <h4>4. Recht auf Löschung</h4>
            <p>
              Sie können nach Art. 17 DS-GVO die Löschung Ihrer
              personenbezogenen Daten verlangen.
            </p>

            <h4>5. Recht auf Einschränkung der Verarbeitung</h4>
            <p>
              Sie haben nach Art. 18 DS-GVO das Recht, eine Einschränkung der
              Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
            </p>

            <h4>6. Recht auf Beschwerde</h4>
            <p>
              Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer
              personenbezogenen Daten gegen Datenschutzrecht verstößt, haben Sie
              nach Art. 77 Abs. 1 DS-GVO das Recht, sich bei einer
              Datenschutzaufsichtsbehörde eigener Wahl zu beschweren. Hierzu
              gehört auch die für den Verantwortlichen zuständige
              Datenschutzaufsichtsbehörde:{" "}
              <a
                href="https://www.datenschutz-berlin.de/"
                target="_blank"
                rel="noopener"
              >
                https://www.datenschutz-berlin.de/
              </a>
            </p>

            <h4>7. Recht auf Datenübertragbarkeit</h4>
            <p>
              Für den Fall, dass die Voraussetzungen des Art. 20 Abs. 1 DS-GVO
              vorliegen, steht Ihnen das Recht zu, sich Daten, die wir auf
              Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags
              automatisiert verarbeiten, an sich oder an Dritte aushändigen zu
              lassen.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
}
